<template>
  <div class="filters">
    <div class="filters__wrap">
      <ul class="filters__list">
        <SingleFilter
          v-for="(value, key) in filters"
          :key="key"
          :title="key"
          :filter="value"
        />
        <!-- <SingleFilter :filter="{ name: 'radius' }" /> -->

        <!-- <svg class="filters__btn">
          <use xlink:href="#icon-sliders-h-regular"></use>
        </svg> -->
        <li
          @click="resetProducts"
          class="filters__clear"
          :class="{ activeClass: selected }"
        >
          Clear Filters
        </li>
      </ul>
      <div @click="setIsMapOpen" class="filter__map">
        <svg>
           <use :xlink:href="isMapOpen ? '#list-light' : '#map-light'"></use>
        </svg>
        {{ isMapOpen ? "List" : "Map" }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
import SingleFilter from "./SingleFilter.vue";
export default {
  name: "Filters",
  components: { SingleFilter },
  computed: {
    ...mapState("products", ["filters"]),
    ...mapState("map", ["isMapOpen"]),
    ...mapGetters("products", ["selected"]),
  },
  methods: {
    ...mapMutations("products", ["setFilters"]),
    ...mapActions("products", ["resetProducts"]),
    ...mapMutations("map", ["setIsMapOpen"]),
  },
};
</script>
